import { connect } from 'react-redux';
import { fetchGuestReservations } from '../../../redux/Guest/sagas/routines';
import {
  getFetching,
  getFetched,
  getOrder
} from '../../../redux/Guest/selectors/reservation';
import {
  clearGuestReservations,
  guestReservationsOnChangePage,
  guestReservationsOnChangeOrder
} from '../../../redux/Guest/actions/reservation';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageReservations
} from '../../../redux/Guest/selectors/reservation/pagination';
import { getGuestReservationSearchQuery } from '../../../redux/Guest/selectors/components/reservation-search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import GuestReservationList from '../../../components/guest/ReservationList';
import orderList from '../../../helpers/reservationOrderList';

function mapStateToProps(state, props) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getGuestReservationSearchQuery(state);
  const order = getOrder(state);
  return {
    data: orderList(order, getCurrentPageReservations(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getFetching(state),
    isFetched: getFetched(state),
    isLegacyView: props.isLegacyView
  };
}

function mapDispatchToProps(dispatch, { guestId }) {
  return {
    onInit: () => {},
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchGuestReservations({ guestId, query }));
      else dispatch(guestReservationsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearGuestReservations());
      dispatch(fetchGuestReservations({ guestId, query }));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      const querySearch = {
        ...query,
        order
      };
      dispatch(clearGuestReservations());
      dispatch(fetchGuestReservations({ guestId, query: querySearch }));
      dispatch(guestReservationsOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestReservationList);
